<template>
  <div class="wrapper">
    <div class="wrapper-in">
      <section class="daftarkan-perolehan">
        <div></div>
      </section>
      <section class="daftarkan-list">
        <Tabs />
      </section>
    </div>
    <div class="daftarkan-button">
      <a
        href="#"
        class="btn btn-primary btn-main btn-daftarkan mb-3 shadow"
        @click.prevent="daftarkanForm()"
      >
        <p><i class="fa fa-plus"></i> Buat Laporan</p>
      </a>
    </div>
  </div>
</template>

<script>
import Tabs from "./tabs.vue";
export default {
  data() {
    return {
      reffcode: "",
    };
  },
  components: {
    Tabs,
  },
  methods: {
    daftarkanForm() {
      const { ref_code } = this.$route.params;

      this.$router.push({
        name: "laporkan-kurban-form",
        params: { ref_code },
        query: { kurban: true },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  display: block;
  position: relative;
  width: 100%;
  max-width: 480px;
  margin: 0px auto;
  box-sizing: border-box;
  top: 0px;
  padding: 10px;
  min-height: calc(100vh - 0px);

  .btn-daftarkan {
    position: fixed;
    bottom: 60px;
    right: 15px;
    padding: 10px !important;
    font-size: 30px;
    border-radius: 8px !important;
    background: #fff !important;
    border: 1px solid #ccc;
    color: #333 !important;
    p {
      font-size: 12px;
      margin: 0px;
      padding: 0px;
      font-weight: bold;
    }
  }

  .wrapper-in {
    padding: 10px 0px;

    section {
      padding: 5px 0px !important;
      clear: both;
    }
  }
}

h5 {
  padding: 0px;
  margin: 0px;
}
</style>
